import { useState } from 'react';

import { Box, Flex, Text } from '@rover/kibble/core';
import type { SearchResult } from '@rover/types/src/apiResponses/FetchSearchResponse';
import type { ServiceTypeSlug } from '@rover/types/src/ServiceType';

import SearchScoreData from '../SearchScoreData';

import NameRow from './NameRow';
import OfferedServices from './OfferedServices';

export type Props = {
  displayExpanded: boolean;
  index?: number;
  searchResult: SearchResult;
  isSeoPage: boolean;
  showRank?: boolean;
  hideHeadline?: boolean;
};

const InfoColumn = ({
  displayExpanded,
  index,
  searchResult: {
    neighborhood,
    city,
    state,
    zip,
    secondaryBadgeData,
    shortName,
    title,
    popoverDebugData,
    browsableServiceSlugs,
    distanceFromSearchCenterObj: { distanceDisplay },
    profileStatusBadgeData,
    rank,
  },
  isSeoPage,
  showRank,
  hideHeadline,
}: Props): JSX.Element => {
  const [isBadgeOpen, setIsBadgeOpen] = useState(false);

  const serviceLocation = [neighborhood, city, state, zip].filter(Boolean).join(', ');

  const handleBadgeChange = (badgeVisible): void => {
    setIsBadgeOpen(badgeVisible);
  };

  return (
    <Flex flex="1 1 0" flexDirection="column" px="4x">
      <NameRow
        badgeData={secondaryBadgeData}
        displayExpanded={displayExpanded}
        name={shortName}
        handleBadgeChange={handleBadgeChange}
        index={index}
        isBadgeOpen={isBadgeOpen}
        profileStatusBadgeData={profileStatusBadgeData}
        rank={rank}
        showRank={showRank}
      />
      {popoverDebugData && <SearchScoreData data={popoverDebugData} />}
      {title && !hideHeadline && (
        <Box
          data-testid="info-column-name"
          display={['none', displayExpanded ? 'block' : 'none']}
          mb="1x"
          sx={{
            hyphens: 'auto',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            wordWrap: 'break-word',
          }}
        >
          <Text size="100">{title}</Text>
        </Box>
      )}
      <Text size="100">{serviceLocation}</Text>
      <Box mb="2x" display={['block', 'none']}>
        <Text size="100">{distanceDisplay}</Text>
      </Box>
      {isSeoPage && <OfferedServices slugs={browsableServiceSlugs as ServiceTypeSlug[]} />}
    </Flex>
  );
};

export default InfoColumn;
